
import { mapState, mapGetters, mapActions } from "vuex";
import chooseOutletLocationDialog from "../dialogs/choose-outlet-location-dialog.vue";
import MenuBookDeliveryLocationCard from "./menu-book-delivery-location-card.vue";

export default {
  components: {
    chooseOutletLocationDialog,
    MenuBookDeliveryLocationCard
  },
  layout: "withBackButtonAndTitle",
  props: {
    restaurantInfo: {
      type: Object,
      required: true
    },
    isOrder: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      showChooseOutletLocation: false
    };
  },
  async mounted() {
    try {
      if (!this.restaurantsList?.length) {
        await this.getRestaurantsList();
      }
      this.checkUserConfig();
    } catch (error) {
      this.$nuxt.$emit("show-error-toast", error);
    }
  },
  computed: {
    ...mapState("restaurant", ["locationDetails"]),
    ...mapGetters("restaurant", ["hasMultipleBrands"]),
    ...mapState("order", ["locationDetails", "cart", "restaurantsList"]),
    ...mapGetters("order", [
      "hasMultipleRestaurants",
      "isRestaurantSelected",
      "isHomeDelivery"
    ]),
    hasRestaurantSwitchingOption() {
      return this.isOrder
        ? this.hasMultipleRestaurants && this.cart.restaurant_id
        : this.hasMultipleBrands;
    },
    getLocatonAddress() {
      if (this.restaurantInfo?.address) {
        return this.restaurantInfo.address;
      } else if (this.locationDetails?.address) {
        return this.locationDetails.address;
      } else {
        return "Address not found";
      }
    }
  },
  methods: {
    ...mapActions("order", ["getInfo", "getRestaurantsList"]),
    checkUserConfig() {
      if (!this.isRestaurantSelected) {
        if (this.hasMultipleBrands) {
          this.showChooseOutletLocation = true;
          return;
        } else {
          this.$ls.set(
            "selected-restaurant",
            this.restaurantsList[0]?.restaurant_id
          );
          this.getInfo();
          return;
        }
      }
    }
  }
};
